export class PrintRoomPropertiesLoadedMessage{}